import React from 'react';
import { useNavigate } from 'react-router-dom';
import { XCircle } from 'lucide-react';
import { Button, Card } from '@/shared/ui';

/**
 * Shown when the user cancels out of the PayPal checkout flow
 * (i.e. they clicked "Cancel" on the PayPal approval page).
 * This does NOT mean their subscription is cancelled — they simply
 * didn't complete the PayPal approval step.
 */
export default function SubscriptionCancelPage(): React.ReactElement {
  const navigate = useNavigate();

  return (
    <div className="flex min-h-screen items-center justify-center bg-slate-50 px-4">
      <Card className="flex max-w-sm flex-col items-center gap-5 py-10 text-center">
        <div className="flex h-16 w-16 items-center justify-center rounded-full bg-slate-100">
          <XCircle size={36} className="text-slate-400" aria-hidden="true" />
        </div>

        <div className="space-y-2">
          <h1 className="text-xl font-bold text-slate-900">Payment not completed</h1>
          <p className="text-sm text-slate-600">
            You left the PayPal checkout before completing your subscription.
            No charge was made. You can try again from your billing page.
          </p>
        </div>

        <div className="flex w-full flex-col gap-2">
          <Button fullWidth onClick={() => navigate('/billing', { replace: true })}>
            Return to billing
          </Button>
          <Button variant="ghost" fullWidth onClick={() => navigate('/dashboard', { replace: true })}>
            Go to dashboard
          </Button>
        </div>
      </Card>
    </div>
  );
}
